export const config = {
  title: "ED & L Concrete LLC | Hockessin, DE",
  meta: {
    description:
      "ED & L Concrete LLC offers professional concrete and landscaping services for residential and commercial properties throughout Hockessin, DE, and surrounding areas. Licensed and insured, delivering quality results since 2020.",
    keywords: [
      "Concrete Services Hockessin DE",
      "Landscaping Hockessin DE",
      "ED & L Concrete",
      "Driveway Installation",
      "Stamped Concrete",
      "Yard Maintenance",
      "Concrete Contractor Delaware",
    ],
    author: "ED & L Concrete LLC",
    canonicalUrl: "https://edlconcretellc.com/",
  },
  sections: {
    header: {
      businessName: "ED & L Concrete LLC",
    },
    sectionB: {
      heroTitle: "Reliable Concrete & Landscaping Solutions",
      heroSubtitle: "Enhancing Properties Across Hockessin and Beyond",
      learnAboutText: "Discover Our Services",
      phoneNumber: "3026075236",
      phoneLabel: "(302) 607-5236",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1310272794/photo/jogging-track-in-garden-of-public-park-among-greenery-trees-flower-shrub-and-bush-black.jpg?s=612x612&w=0&k=20&c=q9TL0c_gdiJUL7OwYF7BpHIZg0fgLAJvqelxbBn7LSM=",
      cardData: [
        {
          title: "Craftsmanship",
          description:
            "Delivers exceptional workmanship with a strong focus on precision, durability, and attention to detail. Every project is built to last and finished with care.",
        },
        {
          title: "Clear Communication",
          description:
            "Ensures consistent updates, transparent expectations, and straightforward coordination throughout the entire project timeline.",
        },
        {
          title: "Fully Licensed and Insured Service",
          description:
            "Strong focus on reliability and long-term value, each job is completed with care, precision, and pride.",
        },
      ],
      description:
        "Since 2020, ED & L Concrete LLC has been committed to delivering top-notch concrete and landscaping services. Our team ensures each project meets the highest standards of quality and customer satisfaction.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Offering a wide range of concrete and landscaping services to meet your residential and commercial needs.",
      cards: [
        {
          title: "Concrete Driveways",
          description:
            "Installation of durable concrete driveways that enhance curb appeal and functionality.",
          imageSrc:
            "https://media.istockphoto.com/id/612258092/photo/smoothing-and-finishing-the-new-concrete-driveway.jpg?s=612x612&w=0&k=20&c=SbHyRKykMPWmbflwk4Zr6Y87Y6BXXkI0uyIgGWoFpuc=",
          imageAlt: "Concrete Driveway",
        },
        {
          title: "Stamped Concrete",
          description:
            "Decorative stamped concrete solutions for patios, walkways, and more.",
          imageSrc:
            "https://media.istockphoto.com/id/1148610614/photo/close-up-view-of-walkway-concrete-stamped-material-selective-focus.jpg?s=612x612&w=0&k=20&c=P1lYLiW1BrvgI0bDPHv68NtmTnWF0pqWyeXpMhxuy24=", // Replace with actual image URL if available
          imageAlt: "Stamped Concrete",
        },
        {
          title: "Landscape Maintenance",
          description:
            "Regular maintenance services to keep your landscape looking its best year-round.",
          imageSrc:
            "https://media.istockphoto.com/id/2150853972/photo/green-grass-cutting-with-lawn-mower-in-home-garden.jpg?s=612x612&w=0&k=20&c=EzSmAvWSwnbVbJxJP6fsMIDbGnPDmJ_VgpBUVUbO1aM=", // Replace with actual image URL if available
          imageAlt: "Landscape Maintenance",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Handicap Ramps",
        "Sidewalks & Curbs",
        "Concrete Foundations",
        "Yard Clean-Up",
        "Mulching Services",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://assets.cdn.filesafe.space/mOABoTdf73S5y9TZ3nXr/media/682e2e068e6261091932abaf.png", // Replace with actual image URL if available
        alt: "ED & L Concrete Team",
      },
      aboutText: [
        "ED & L Concrete LLC is a licensed and insured company based in Hockessin, DE, specializing in concrete and landscaping services since 2020.",
        "Our mission is to provide high-quality services that enhance the functionality and appearance of our clients' properties.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "ED & L Concrete LLC Logo",
      businessName: "ED & L Concrete LLC",
      contact: {
        phone: "3026075236",
        phoneLabel: "(302) 607-5236",
        email: "contact@edlconcretellc.com",
        website: "https://edlconcretellc.com/",
        address: "3 Aston Cir, Hockessin, DE 19707",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/edlconcrete/",
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "3 Aston Cir, Hockessin, DE 19707",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3068.123456789!2d-75.1234567!3d39.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6c123456789ab%3A0xabcdef1234567890!2s3%20Aston%20Cir%2C%20Hockessin%2C%20DE%2019707!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus",
    },
  },
};

export default config;
